import React from 'react'
import { Link } from 'gatsby'
import FooterLinksGroup from '../footer-links-group/FooterLinksGroup'
import { LINKS_GROUP_SET } from './const/links-group-set.conts'
import './footer.scss'

// const query = graphql`
//   query Info {
//     site {
//       buildTime(formatString: "DD.MM.YYYY HH:mm:ss")
//     }
//   }
// `

export const Footer = () => {
  // const buildTime = useStaticQuery<InfoQuery>(query).site.buildTime

  return (
    <footer className={'la-page-footer'}>
      <div className={'la-footer-content'}>
        <ul className={'la-footer-content__top la-footer-col-set'}>
          {LINKS_GROUP_SET.map((group, i) => (
            <li className={'la-footer-col-set__item'} key={i}>
              <FooterLinksGroup title={group.title} links={group.links} contacts={group.contacts} />
            </li>
          ))}
        </ul>

        <div className={'la-footer-content__bottom'}>
          <div className="copyright">
            <div className="copyright-row">
              <span className="copyright-row__copyright">
                Copyright {new Date().getFullYear()} – LiveAction. All Rights Reserved.
              </span>

              <div className="copyright-row__links">
                <a className="la-link" href="https://www.liveaction.com/terms-of-use/">
                  Terms of Use
                </a>
                <a className="la-link" href="https://www.liveaction.com/privacy-policy/">
                  Privacy Policy
                </a>
                <a href="https://www.liveaction.com/terms-and-conditions/" className="la-link">
                  Software License &amp; Maintenance Agreement
                </a>
              </div>
            </div>

            <p className="copyright-row">
              <span>901 Campisi Way, Ste. 222, Campbell, CA 95008, USA</span>
              <a className={'la-link'} href={'tel:+18888811116'}>
                +1 (888) 881-1116
              </a>
            </p>
          </div>

          <Link className="logo" to={'/'} />
        </div>
      </div>
    </footer>
  )
}
